module.exports = __webpack_public_path__ + "static/media/EX_FINISHED_alt_7.e79fac66.mp3";